import React from "react";
const images = require.context("../assets/images", false);


function Socail_banner() {

  return (
    <>
 <div className="add-banner">
  <img src={images("./support-banner.jpeg")} />
</div>

</>
  );
}

export default Socail_banner;